import * as moment from 'moment';
import { getConfigurations } from 'src/modules/api';
import { getI18n } from 'react-i18next';
import { updateLocale } from './moment';

export const updateConfiguration = () => {
    const i18n = getI18n();
    return getConfigurations().then(response => {
        const { data: { result: { timeZone, currentLanguage, languages } } } = response;
        moment.tz.setDefault(timeZone);
        updateLocale(currentLanguage.name);
        i18n.changeLanguage(currentLanguage.name);

        return { timeZone, currentLanguage, languages };
    });
};



// WEBPACK FOOTER //
// ./src/modules/appConfiguration.ts